import { useEffect, useMemo, useState } from 'react'
import TextInput from '../../ui/TextInput/TextInput'
import styles from './AuthPage.module.scss'
import Layout from '../../ui/Layout/Layout'
import Button from '../../ui/Button/Button'
import { useCreateAccaunt, useLogin } from '../../hooks/auth'
import { useLocation, useNavigate } from 'react-router-dom'

type TMode = 'login' | 'create' | 'confirm'

export default function AuthPage() {
  const navigate = useNavigate()
  const location = useLocation()

  const redirectAfter = useMemo(() => {
    const pairs = location.search.substring(1).split('&')
    const redirectAfterPair = pairs.find(pair => pair.includes("redirectAfter"))
    return redirectAfterPair?.split('=')[1] || ''
  }, [location])
  const hash = useMemo(() => {
    return location.hash || ''
  }, [location])

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const [mode, setMode] = useState<TMode>('login')

  const login = useLogin()
  const createAccaunt = useCreateAccaunt()

  useEffect(() => {
    if (login.isSuccess) {
      navigate(`/${redirectAfter}${hash}`)
      login.reset()
    }
  }, [login])

  useEffect(() => {
    if (createAccaunt.isSuccess) {
      setMode('confirm')
      createAccaunt.reset()
    }
  }, [createAccaunt])

  return (
    <div className={styles.root}>
      <Layout className={styles.form} kind='white'>
        {mode === 'login' &&
          <>
            <h2>Вход в аккаунт</h2>
            <TextInput
              label='Почта'
              type='email'
              autoComplete="email"
              placeholder="Введите e-mail"
              name="email"
              value={email}
              setValue={setEmail}
              className={styles.input}
            />
            <TextInput
              label='Пароль'
              type='password'
              value={password}
              placeholder="Введите пароль"
              autoComplete="current-password"
              name="password"
              setValue={setPassword}
              className={styles.input}
            />
            <p className={styles.noacc}>Нет аккаунта? 
              <span className={styles.changeMode} onClick={() => {setMode('create')}}>
                {' Создать'}
              </span>
            </p>
            <Button 
              className={styles.btn}
              onClick={async () => {
                login.mutate({email, password}, {onError: () => {alert("Введены некорректные данные")}})
              }}
            >
              <p>Войти</p>
            </Button>
          </>
        }

        {mode === 'create' &&
          <>
            <h2>Создание аккаунта</h2>
            <TextInput
              label='Почта'
              type='email'
              value={email}
              setValue={setEmail}
              className={styles.input}
            />
            <TextInput
              label='Пароль'
              type='password'
              value={password}
              setValue={setPassword}
              className={styles.input}
            />
            <p className={styles.noacc}>Есть аккаунт? 
              <span className={styles.changeMode} onClick={() => {setMode('login')}}>
                {' Войти'}
              </span>
            </p>
            <Button 
              className={styles.btn} 
              onClick={() => {
                createAccaunt.mutate({email, password}, {onError: () => {alert("Аккаунт с такой почтой уже существует.")}})
              }}
            >
              <p>Создать</p>
            </Button>
          </>
        }

        {mode === 'confirm' &&
          <>
            <h3>Письмо для подтверждения почты было отправлено на указанный адрес.</h3>
            <p>Если письмо не пришло, проверьте папку "Спам". На подтверждение дается 5 минут, иначе аккаунт будет удален.</p>
          </>
        }
        
      </Layout>
    </div>
  )
}